<template>
  <div>
    <manageAssistantTeacherBarVue />
    <v-container fluid class="grey lighten-4 pa-6">
      <base-material-card
        icon="mdi-account-star"
        :title="
          `ระบบรายงานตัวและอนุมัติข้อมูลครูผู้ช่วย รอบที่ ${periodassteachs.periodAssTeachTimes} / ${periodassteachs.periodAssTeachYear}`
        "
        class="px-5 py-3"
      >
        <v-row class="mb-4">
          <v-col cols="12" md="2">
            <v-card
              color="info"
              dark
              class="text-center pa-4 elevation-4"
              @click="manage_assistant_teacherQueryAll()"
            >
              <div class="text-h4 font-weight-bold">{{ count_alls }}</div>
              <div class="text-subtitle-2">จำนวนทั้งหมด</div>
              <v-icon large class="mt-2">mdi-account-group</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="success"
              dark
              class="text-center pa-4 elevation-4"
              @click="manage_assistant_teacherSearchStatus('receipt')"
            >
              <div class="text-h4 font-weight-bold">{{ count_receipts }}</div>
              <div class="text-subtitle-2">รายงานตัวแล้ว</div>
              <v-icon large class="mt-2">mdi-check-decagram</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="orange darken-2"
              dark
              class="text-center pa-4 elevation-4"
              @click="
                manage_assistant_teacherSearchTypeTran('transfer_position')
              "
            >
              <div class="text-h4 font-weight-bold">
                {{ count_transfer_position }}
              </div>
              <div class="text-subtitle-2">ครูโอนย้าย</div>
              <v-icon large class="mt-2">mdi-swap-horizontal</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="error"
              dark
              class="text-center pa-4 elevation-4"
              @click="manage_assistant_teacherSearchStatus('missing')"
            >
              <div class="text-h4 font-weight-bold">{{ count_missings }}</div>
              <div class="text-subtitle-2">ไม่มารายงานตัว</div>
              <v-icon large class="mt-2">mdi-account-remove</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="warning"
              dark
              class="text-center pa-4 elevation-4"
              @click="manage_assistant_teacherSearchStatus('send')"
            >
              <div class="text-h4 font-weight-bold">{{ count_sends }}</div>
              <div class="text-subtitle-2">รอการรายงาน</div>
              <v-icon large class="mt-2">mdi-clock-outline</v-icon>
            </v-card>
          </v-col>
          <v-col cols="12" md="2">
            <v-card
              color="purple"
              dark
              class="text-center pa-4 elevation-4"
              @click="manage_assistant_teacherCancelQueryAll()"
            >
              <div class="text-h4 font-weight-bold">
                {{
                  manage_assistant_teachers.filter(t => t.mt_collegeCC === "CC")
                    .length
                }}
              </div>
              <div class="text-subtitle-2">ขอยกเลิกข้อมูล</div>
              <v-icon large class="mt-2">mdi-alert-octagon</v-icon>
            </v-card>
          </v-col>
        </v-row>

        <v-card class="mb-4 pa-4" outlined>
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ชื่อ-นามสกุล หรือ รหัสบัตรประชาชน"
                outlined
                dense
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="SearchBranch"
                :items="manage_assistant_teacherGroupBranch"
                item-text="name_branch"
                item-value="mt_id_branch"
                label="กรองตามสาขาวิชา"
                outlined
                dense
                hide-details
                @change="manage_assistant_teacherSearchBranchQueryAll"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="Searchcollege_code"
                :items="manage_assistant_teacherGroupCollege"
                item-text="college_name"
                item-value="college_code"
                label="กรองตามสถานศึกษา"
                outlined
                dense
                hide-details
                @change="manage_assistant_teacherSearchCollegeQueryAll"
              />
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12" class="d-flex flex-wrap">
              <v-btn
                color="info"
                depressed
                class="mr-2 mb-2"
                @click="manage_assistant_teacherTotal"
              >
                <v-icon left>mdi-chart-pie</v-icon>สรุปยอดสาขา
              </v-btn>
              <v-btn
                color="success"
                depressed
                class="mr-2 mb-2"
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon>ส่งออก Excel
              </v-btn>
              <v-btn
                color="primary"
                depressed
                class="mr-2 mb-2"
                @click="manage_assistant_teacherPrintReport"
              >
                <v-icon left>mdi-printer</v-icon>พิมพ์รายงาน PDF
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                depressed
                dark
                class="mb-2"
                @click="ApproveCollegeReport"
              >
                <v-icon left>mdi-checkbox-multiple-marked</v-icon
                >อนุมัติบันทึกข้อมูลเข้าฐานระบบใหญ่
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="manage_assistant_teachers"
          :search="search"
          group-by="mt_college_code"
          class="elevation-2"
          :items-per-page="50"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th colspan="20" class="group-header">
              <v-btn icon small @click="toggle" class="mr-2">
                <v-icon>{{ isOpen ? "mdi-minus-box" : "mdi-plus-box" }}</v-icon>
              </v-btn>
              <span class="text-h6 blue--text text--darken-4">
                {{ items[0].mt_college_code }} : {{ items[0].college_name }}
              </span>
              <v-chip small color="primary" class="ml-4"
                >จำนวน {{ items.length }} รายการ</v-chip
              >
            </th>
          </template>

          <template v-slot:item.mt_sequence="{ item }">
            <v-chip dark color="blue-grey darken-2" label>
              <strong style="font-size: 16px;">{{ item.mt_sequence }}</strong>
            </v-chip>
          </template>

          <template v-slot:item.mt_id_card="{ item }">
            <span class="hide-idcard-number">{{ item.mt_id_card }}</span>
          </template>

          <template v-slot:item.mt_admissions_status="{ item }">
            <div v-if="item.mt_id === editedItem.mt_id">
              <v-select
                v-model="editedItem.mt_admissions_status"
                :items="mt_admissions_statusSe"
                dense
                outlined
                hide-details
              />
            </div>
            <v-chip
              v-else
              :color="
                item.mt_admissions_status === 'receipt'
                  ? 'success'
                  : item.mt_admissions_status === 'missing'
                  ? 'error'
                  : 'warning'
              "
              dark
              small
              label
              @click="editItem(item)"
            >
              <v-icon left small>mdi-account-check</v-icon>
              {{
                item.mt_admissions_status === "receipt"
                  ? "รายงานตัวแล้ว"
                  : item.mt_admissions_status === "missing"
                  ? "ไม่มารายงานตัว"
                  : "รอการรายงาน"
              }}
            </v-chip>
          </template>

          <template v-slot:item.mt_collegeCC="{ item }">
            <v-chip
              v-if="item.mt_collegeCC === 'CC'"
              color="error"
              dark
              small
              @click="CancelAdmissions(item.mt_id)"
            >
              <v-icon left small>mdi-alert-circle</v-icon>ขอยกเลิกข้อมูล
            </v-chip>
            <v-chip
              v-else-if="item.mt_collegeCC === 'CF'"
              color="success"
              outlined
              small
            >
              <v-icon left small>mdi-account-check</v-icon>อนุมัติแล้ว
            </v-chip>
            <span v-else>-</span>
          </template>

          <template v-slot:item.mt_examgroup="{ item }">
            <v-chip
              x-small
              dark
              :color="item.mt_examgroup === 'southern' ? 'indigo' : 'purple'"
            >
              {{ item.mt_examgroup === "southern" ? "จชต." : "ทั่วไป" }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex align-center">
              <v-btn
                v-if="
                  item.mt_committe_status === 'CF' && item.mt_collegeCC !== 'CF'
                "
                color="primary"
                small
                depressed
                @click="ConfirmAssistantTeach(item.mt_id)"
              >
                อนุมัติบุคคล
              </v-btn>
              <v-icon v-if="item.mt_collegeCC === 'CF'" color="success"
                >mdi-check-all</v-icon
              >

              <v-menu offset-y v-if="item.mt_id !== editedItem.mt_id">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="editItem(item)">
                    <v-list-item-title
                      ><v-icon left small>mdi-pencil</v-icon
                      >แก้ไขสถานะ</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    @click="deleteItem(item.mt_id, item.mt_id_position)"
                  >
                    <v-list-item-title class="red--text"
                      ><v-icon left small color="red">mdi-delete</v-icon
                      >ลบรายการ</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>

              <div v-if="item.mt_id === editedItem.mt_id">
                <v-btn icon color="success" @click="save()"
                  ><v-icon>mdi-check-bold</v-icon></v-btn
                >
                <v-btn icon color="error" @click="close"
                  ><v-icon>mdi-close-thick</v-icon></v-btn
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </base-material-card>
    </v-container>

    <v-dialog
      v-model="editmanage_assistant_teacherdialog"
      persistent
      max-width="700px"
    >
      <v-card class="rounded-xl">
        <v-toolbar flat color="error" dark>
          <v-toolbar-title>จัดการคำร้องขอยกเลิกข้อมูล</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="editmanage_assistant_teacherdialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="12" md="6">
              <div class="text-caption grey--text">เลขบัตรประชาชน</div>
              <div class="text-h6">
                {{ editmanage_assistant_teacher.mt_id_card }}
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-caption grey--text">ชื่อ-นามสกุล</div>
              <div class="text-h6">
                {{ editmanage_assistant_teacher.mt_title_s
                }}{{ editmanage_assistant_teacher.mt_frist_name }}
                {{ editmanage_assistant_teacher.mt_last_name }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-alert type="warning" outlined class="mb-4"
                >วิทยาลัยขอยกเลิกการรายงานตัวเนื่องจากข้อมูลผิดพลาด</v-alert
              >
              <v-select
                v-model="
                  editmanage_assistant_teacher.mt_admissions_statusSelect
                "
                :items="mt_admissions_status_select"
                label="สถานะที่จะปรับเปลี่ยนใหม่"
                outlined
                rounded
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-btn
            text
            large
            rounded
            @click="editmanage_assistant_teacherUpdateSubmit()"
            >เฉพาะบันทึกสถานะ</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            large
            rounded
            class="px-8"
            @click="editmanage_assistant_teacherSubmit()"
          >
            อนุมัติยกเลิกและคืนสิทธิ์
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="Confirmmanage_assistant_teacherdialog"
      persistent
      max-width="800px"
    >
      <v-card class="rounded-xl pa-4">
        <v-card-title class="info--text text-h5 font-weight-bold">
          <v-icon left color="info">mdi-account-check</v-icon
          >ยืนยันการอนุมัติบรรจุครูผู้ช่วย
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="12" md="4" class="text-center">
              <v-avatar size="120" color="grey lighten-3">
                <v-icon size="80" color="grey">mdi-account</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="12" md="8">
              <div class="text-h6">
                {{ editmanage_assistant_teacher.mt_name }}
              </div>
              <div class="grey--text">
                {{ editmanage_assistant_teacher.name_branch }}
              </div>
              <v-divider class="my-4"></v-divider>
              <v-menu
                v-model="menu4"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editmanage_assistant_teacher.mt_dateAppoint"
                    label="วันที่บรรจุ/เริ่มปฏิบัติงาน"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    rounded
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editmanage_assistant_teacher.mt_dateAppoint"
                  @input="menu4 = false"
                  locale="th"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-subheader>คณะกรรมการประเมิน</v-subheader>
          <v-simple-table dense>
            <thead>
              <tr class="grey lighten-4">
                <th>ประเภทกรรมการ</th>
                <th>ชื่อ-นามสกุล</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="committee in assistantcommittees"
                :key="committee.committeeName"
              >
                <td>
                  {{
                    committee.assistantcommitteePositon === "1"
                      ? "ผู้ทรงคุณวุฒิภายนอก"
                      : "กรรมการภายใน"
                  }}
                </td>
                <td>{{ committee.committeeName }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="Confirmmanage_assistant_teacherdialog = false"
            >ปิด</v-btn
          >
          <v-btn
            color="primary"
            class="px-8"
            rounded
            @click="Confirmmanage_assistant_teacherSubmit()"
          >
            <v-icon left>mdi-check-decagram</v-icon>บันทึกอนุมัติบรรจุ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import manageAssistantTeacherBarVue from "../../../components/admin/manageAssistantTeacherBar.vue";
import * as XLSX from "xlsx"; // นำเข้าสำหรับ Export Excel

export default {
  name: "HRvecManageAssistantTeacher",
  components: { manageAssistantTeacherBarVue },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      search: "",
      searchApprove: "",
      SearchBranch: "",
      Searchcollege_code: "",

      // ตัวแปรเก็บข้อมูล
      manage_assistant_teachers: [],
      manage_assistant_teacherGroupBranch: [],
      manage_assistant_teacherGroupCollege: [],
      manage_assistant_teacherCount: [],
      editmanage_assistant_teacher: {},
      periodassteachs: {},
      assistantcommittees: [],

      // การทำงานของ Dialog
      editmanage_assistant_teacherdialog: false,
      Confirmmanage_assistant_teacherdialog: false,
      manage_assistant_teacherCountDialog: false,
      manage_assistant_teacherApproveDialog: false,
      pdfmt_admissions_filedialog: false,
      menu4: false,

      // ยอดสรุป Dashboard
      count_alls: 0,
      count_sends: 0,
      count_receipts: 0,
      count_missings: 0,
      count_transfer_position: 0,

      // Headers ตาราง
      headers: [
        { text: "ลำดับ", value: "mt_sequence", width: "80px", sortable: true },
        { text: "รหัสบัตรประชาชน", value: "mt_id_card", width: "160px" },
        { text: "ชื่อ-นามสกุล", value: "mt_name" },
        { text: "ประเภท", value: "mt_examgroup", align: "center" },
        { text: "สาขาวิชา", value: "name_branch" },
        {
          text: "สถานะรายงานตัว",
          value: "mt_admissions_status",
          align: "center"
        },
        { text: "คำร้องขอยกเลิก", value: "mt_collegeCC", align: "center" },
        { text: "ดำเนินการ", value: "actions", sortable: false, align: "right" }
      ],

      mt_admissions_statusSe: [
        { text: "รายงานตัวปกติ (Receipt)", value: "receipt" },
        { text: "ไม่มารายงานตัว (Missing)", value: "missing" }
      ],
      mt_admissions_status_select: [
        { text: "มารายงานตัว", value: "receipt" },
        { text: "ไม่มารายงานตัว", value: "missing" }
      ],

      editedItem: { mt_id: 0, mt_college_code: "" },
      insertselects: {}
    };
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;
      try {
        await this.periodassteachQuery();
        await this.manage_assistant_teacherQueryAll();
        await this.manage_assistant_teacherGroupBranchQueryAll();
        await this.manage_assistant_teacherGroupCollegeCodeQueryAll();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    // ฟังก์ชัน Export Excel สมบูรณ์
    exportToExcel() {
      const data = this.manage_assistant_teachers.map(item => ({
        "รอบ/ปี": `${item.mt_times}/${item.mt_years}`,
        วิทยาลัย: item.college_name,
        สาขา: item.name_branch,
        ลำดับ: item.mt_sequence,
        รหัสบัตรประชาชน: item.mt_id_card,
        "ชื่อ-นามสกุล": item.mt_name,
        สถานะ:
          item.mt_admissions_status === "receipt"
            ? "รายงานตัวแล้ว"
            : "ไม่รายงานตัว",
        เลขที่ตำแหน่ง: item.mt_id_position,
        ประเภท: item.mt_examgroup
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "รายชื่อครูผู้ช่วย");
      XLSX.writeFile(
        wb,
        `รายงานครูผู้ช่วย_รอบ${this.periodassteachs.periodAssTeachTimes}_${this.periodassteachs.periodAssTeachYear}.xlsx`
      );
    },

    async manage_assistant_teacherQueryAll() {
      this.loading = true;
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_times: this.periodassteachs.periodAssTeachTimes,
        mt_years: this.periodassteachs.periodAssTeachYear,
        mt_report: "Ok"
      });
      this.manage_assistant_teachers = result.data;
      this.calculateDashboard();
      this.loading = false;
    },

    calculateDashboard() {
      const data = this.manage_assistant_teachers;
      this.count_alls = data.length;
      this.count_sends = data.filter(
        v => v.mt_admissions_status === "send"
      ).length;
      this.count_receipts = data.filter(
        v => v.mt_admissions_status === "receipt"
      ).length;
      this.count_missings = data.filter(
        v => v.mt_admissions_status === "missing"
      ).length;
      this.count_transfer_position = data.filter(
        v => v.mt_type_personnel === "transfer_position"
      ).length;
    },

    // จัดการ Dialog และการแก้ไข
    editItem(item) {
      this.editedItem = Object.assign({}, item);
    },
    close() {
      this.editedItem = { mt_id: 0 };
    },
    async save() {
      this.editedItem.ApiKey = this.ApiKey;
      let result = await this.$http.post(
        "manage_assistant_teacher.update.php",
        this.editedItem
      );
      if (result.data.status) {
        Swal.fire({
          icon: "success",
          title: "บันทึกสถานะเรียบร้อย",
          timer: 1000
        });
        this.manage_assistant_teacherQueryAll();
        this.close();
      }
    },

    // อนุมัติยกเลิกข้อมูล (จากวิทยาลัยร้องขอ)
    async editmanage_assistant_teacherSubmit() {
      Swal.fire({
        title: "ยืนยันการยกเลิกรายงานตัว?",
        text: "สถานะจะถูกรีเซ็ตและคืนสิทธิ์ให้วิทยาลัยรายงานใหม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยันอนุมัติ"
      }).then(async res => {
        if (res.isConfirmed) {
          this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
          this.editmanage_assistant_teacher.mt_admissions_status = "send"; // คืนเป็นสถานะรอส่งข้อมูล
          this.editmanage_assistant_teacher.mt_collegeCC = ""; // เคลียร์สถานะขอยกเลิก

          await this.$http.post(
            "manage_assistant_teacher.update.php",
            this.editmanage_assistant_teacher
          );
          this.manage_assistant_teacherQueryAll();
          this.editmanage_assistant_teacherdialog = false;
        }
      });
    },

    // อนุมัติบรรจุ (ลงทะเบียนเข้า Personnel_Temporary)
    async ConfirmAssistantTeach(mt_id) {
      let res = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = res.data;

      // ดึงข้อมูลกรรมการ
      let resAs = await this.$http.post("assistantcommittee.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeTime: this.editmanage_assistant_teacher.mt_times,
        assistantcommitteeYear: this.editmanage_assistant_teacher.mt_years,
        assistantcommitteeIDCardTeach: this.editmanage_assistant_teacher
          .mt_id_card
      });
      this.assistantcommittees = resAs.data;
      this.Confirmmanage_assistant_teacherdialog = true;
    },

    async Confirmmanage_assistant_teacherSubmit() {
      const data = {
        ApiKey: this.ApiKey,
        mt_id: this.editmanage_assistant_teacher.mt_id,
        mt_collegeCC: "CF", // Confirm
        mt_dateAppoint: this.editmanage_assistant_teacher.mt_dateAppoint
      };

      let result = await this.$http.post(
        "manage_assistant_teacher.update.php",
        data
      );
      if (result.data.status) {
        Swal.fire("สำเร็จ", "อนุมัติบรรจุครูเรียบร้อยแล้ว", "success");
        this.initialize();
        this.Confirmmanage_assistant_teacherdialog = false;
      }
    },

    // ส่วน Query พื้นฐาน
    async periodassteachQuery() {
      let res = await this.$http.post("periodassteach.php", {
        ApiKey: this.ApiKey,
        periodAssTeachEnablePro: "1"
      });
      this.periodassteachs = res.data;
    },
    async manage_assistant_teacherGroupBranchQueryAll() {
      let res = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_times: this.periodassteachs.periodAssTeachTimes,
        mt_years: this.periodassteachs.periodAssTeachYear,
        mt_SELECTBranch: "Ok"
      });
      this.manage_assistant_teacherGroupBranch = res.data;
    },
    async manage_assistant_teacherGroupCollegeCodeQueryAll() {
      let res = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_times: this.periodassteachs.periodAssTeachTimes,
        mt_years: this.periodassteachs.periodAssTeachYear,
        mt_selectCollege: "Ok"
      });
      this.manage_assistant_teacherGroupCollege = res.data;
    }
  }
};
</script>

<style scoped>
.group-header {
  background-color: #f1f8ff;
  border-bottom: 2px solid #2196f3;
}
.hide-idcard-number {
  display: inline-block;
  font-family: monospace;
  position: relative;
}
.hide-idcard-number::after {
  content: "XXXX-XXXX";
  background: #e0e0e0;
  color: #757575;
  border-radius: 4px;
  padding: 0 4px;
  margin-left: -60px;
}
</style>
